angular
    .module('tradersyard')
    .factory('GuidFactory', [
        function () {
            function Generate() {
                function s4() {
                    return Math.floor((1 + Math.random()) * 0x10000)
                        .toString(16)
                        .substring(1);
                }

                return [s4(), s4(), '-', s4(), '-', s4(), '-', s4(), '-', s4(), s4(), s4()].join('');
            }

            return {
                Generate: Generate,
            };
        },
    ])
    .factory('PaginationFactory', [
        function () {
            /**
             * @typedef PaginateOptions
             * @property {number} page Initial page
             * @property {Object} queryFilters Query string parameters to apply to the request
             */

            /**
             * @typedef PaginateData
             * @property {Array} items - Items returned by page query
             * @property {number} totalPages - Number of total pages taken from server response
             */

            /**
             * @param {Function} loadPageFn Functions that will load a given page and return a Promise with required data.
             * @param {PaginateOptions} options
             * @constructor
             */
            function Paginate(loadPageFn, options) {
                var self = this;

                var _queryFilters = {};

                /**
                 * Should load page data and return a Promise
                 * @type {Function}
                 */
                self.loadPageFn = loadPageFn;

                /**
                 * Called when loadPageFn resolves successfully.
                 * You can overwrite this function and treat it as a listener.
                 * @param {PaginateData} paginationData
                 */
                self.onPageLoad = function (paginationData) {};

                /**
                 * Called when pagination is `.reset()`
                 * You can overwrite this function and treat it as a listener.
                 */
                self.onReset = function () {};

                self.currentPage = 1;

                /**
                 * Total number of pages. It will be set on initial data load based on data returned from server.
                 * @type {number}
                 */
                self.totalPages = 0;

                // Initialize pagination by loading first page of data
                self.reset = reset;
                self.reset(options);

                /**
                 * Loads the next page of data.
                 */
                self.nextPage = function () {
                    loadPage(++self.currentPage);
                };

                /**
                 * Reset (or initialize) the pagination.
                 * @param {PaginateOptions} options
                 */
                function reset(options) {
                    self.onReset();

                    options = options || {};

                    self.currentPage = options.page || 1;
                    _queryFilters = options.queryFilters || {};

                    loadPage(self.currentPage);
                }

                /**
                 * Loads a given page. Respects query filters.
                 * @param {number} page Page number
                 */
                function loadPage(page) {
                    var queryParams = angular.extend({}, { page: page }, _queryFilters);
                    self.loadPageFn(queryParams).then(onLoadSuccess);
                }

                /**
                 * @param {PaginateData} paginationData
                 * @returns {PaginateData}
                 */
                function onLoadSuccess(paginationData) {
                    // this callback has access to returned items
                    self.onPageLoad(paginationData);
                    // we now know total pages
                    self.totalPages = paginationData.totalPages;
                    return paginationData;
                }
            }

            return {
                paginate: Paginate,
            };
        },
    ])
    .service('GraphTitleFactory', [
        '$location',
        '$document',
        function ($location, $document) {
            var titleNode = document.querySelector('head title');
            var titleNgEl = angular.element(titleNode);
            var titleTVal = titleNgEl.text();
            var breaker = '|';
            var missVal = 0;
            var parserVal = titleTVal;

            if (/^\([0-9]+\)/i.test(parserVal) === true) {
                parserVal = parseInt(parserVal.match(/^\(([0-9]+)\)/)[1]);
                parserVal = parserVal.replace(/^\([0-9]+\)(\s+|)/, '');
            }

            var atomVal = parserVal.split(breaker);

            var currVal = atomVal[0].trim();
            var postVal = atomVal[1] !== undefined ? atomVal[1].trim() : undefined;

            function setTitleText() {
                var textContent = missVal > 0 ? '(' + missVal + ') ' + currVal : currVal;

                if (postVal !== undefined) {
                    textContent += ' | ' + postVal;
                }

                titleNgEl.text(textContent);
            }

            function setMissValue(value, reapply) {
                missVal = value;
                if (reapply !== false) {
                    setTitleText();
                }
            }

            function getMissValue() {
                return missVal;
            }

            return {
                setTitleText: setTitleText,
                setMissValue: setMissValue,
                getMissValue: getMissValue,
            };
        },
    ])
    .run([
        'GraphTitleFactory',
        function (GraphTitleFactory) {
            // silence
        },
    ])
    .factory('graph-tooltip-storage', [
        'graph-tooltip-factory',
        function ($factory) {
            var $tooltips = [];

            function make(entry, entryId) {
                return entry + ':' + entryId;
            }

            return {
                get: function (entry, entryId, next) {
                    var space = make(entry, entryId);

                    if ($tooltips[space] === undefined) {
                        $factory
                            .entry(entry, entryId)
                            .read()
                            .then(function (response) {
                                if (response.data.state === 0) {
                                    $tooltips[space] = response.data.data;

                                    next($tooltips[space]);
                                }
                            });
                    } else {
                        next($tooltips[space]);
                    }
                },
            };
        },
    ])
    .factory('form-common', [
        function () {
            return {
                datetime: {
                    gather: function (date, time) {
                        date = moment(date[0], date[1]);
                        time = time[0].split(time[1]);

                        date.set({
                            hour: parseInt(time[0], 10),
                            minute: parseInt(time[1], 10),
                        });

                        return date;
                    },
                    parse: function (datetime, format) {
                        return moment(datetime, format);
                    },
                },
            };
        },
    ])
    .factory('$moment', [
        function () {
            var timezone = moment.tz.guess(),
                language = 'en';

            moment.locale(language);

            return {
                timezone: function (value) {
                    if (value === undefined) return timezone;

                    if (moment.tz.zone(value) === true) {
                        timezone = value;

                        moment.tz.setDefault(value);
                    }

                    return this;
                },
                language: function (value) {
                    if (value === undefined) return language;

                    if (moment.locales().indexOf(value) !== -1) {
                        language = value;

                        moment.locale(value);
                    }

                    return this;
                },
            };
        },
    ]);
